import React, { useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import PrimaryButton from '../buttons/PrimaryButton';
import { useTranslation } from 'react-i18next';

interface SearchInputProps {
    placeholder: string;
    onSearch?: (query: string) => void;
    variant?: 'neutral' | 'primary';
    disabled?: boolean;
}

const SearchInput = (props: SearchInputProps) => {
    const { t } = useTranslation();
    const [query, setQuery] = React.useState('');

    const handleSearch = (): void => {
        if (props.onSearch) {
            props.onSearch(query);
        }
    }

    useEffect(() => {
        handleSearch();
    }, [query]);

    function getBackgroundClassName() {
        if (props.disabled) {
            return "bg-utility-muted";
        }
        if (props.variant === 'neutral') {
            return 'bg-neutral-deep';
        }
        return 'bg-utility-muted';
    }

    return (
        <div className={`${getBackgroundClassName()} border-none outline-none flex items-center w-full border rounded-[16px] shadow-sm h-[44px]`}>
            <div className="pl-3 text-primary">
                <SearchIcon />
            </div>
            <input
                type="text"
                className={`${getBackgroundClassName()} w-full box-border px-3 py-2 focus:outline-none text-[16px] text-primary-dark`}
                placeholder={props.placeholder}
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                disabled={props.disabled}
            />
            <PrimaryButton
                onClick={handleSearch}
                disabled={props.disabled}
            >
                {t('common.search')}
            </PrimaryButton>
        </div>
    )
}

export default SearchInput